import React from 'react';
import VideoPreview from '../../core/components/videoPreview';
import video1 from 'images/landing/first_closed.jpg';
import video2 from 'images/landing/second_closed.jpg'
import video3 from 'images/landing/third_closed.jpg'
import video4 from 'images/landing/fourth_closed.jpg'
import bgImage from 'images/white-bg-elements1.svg'
import {Link} from 'react-router-dom'
import ReactSlickSlider from 'react-slick';

export default function (props) {


  const sliderSettings = {
    dots          : false,
    fade          : false,
    arrows        : false,
    infinite      : false,
    accessibility : true,
    speed         : 1200,
    slidesToShow  : 4,
    slickGoTo     : 0,
    draggable     : false,
    swipe         : false,
    swipeToSlide  : false,
    responsive    : [{
      breakpoint: 768,
      settings  : {
        slidesToShow  : 2,
        slidesToScroll: 1,
        arrows        : true
      }
    },
      {
        breakpoint: 500,
        settings  : {
          slidesToShow  : 1,
          slidesToScroll: 1,
          arrows        : true
        }
      }
    ]
  };


  const videosArray = [{
    placeholder: {
      img: video1,
      alt: 'video'
    },
    title      : 'Atrial Fibrillation',
    time       : ''
  }, {
    placeholder: {
      img: video2,
      alt: 'video'
    },
    title      : 'Migraine',
    time       : ''
  },
    {
      placeholder: {
        img: video3,
        alt: 'video'
      },
      title      : 'Hypertension',
      time       : ''
    },
    {
      placeholder: {
        img: video4,
        alt: 'video'
      },
      title      : 'COPD',
      time       : ''
    }
  ];

  const videoItem = videosArray.map((item, index) => {
    return (
      <div  key={index}>
        <VideoPreview
          placeholder={item.placeholder}
          title={item.title}
          time={item.time}
          locked={true}/>
      </div>
    )
  });


  return (

    <section className="tutorials" id="pricingContainer">
      <div className="section-wrap">
        <img src={bgImage}
             onLoad={() => props.scroll()}
             className="picture" alt="picture"/>
        <div className="container-fluid">
          <div className="row justify-content-center align-self-center">
            <div className="col-lg-12">
              <div className="content-wrap">
                <h1 className="section-title">
                  ACCESS ALL TOPICS NOW
                </h1>
                {/*<div className="row">*/}
                    {/*{videoItem}*/}
                {/*</div>*/}
                {/* <ReactSlickSlider {...sliderSettings} >
                  {videoItem}
                </ReactSlickSlider> */}
                <div className="button-set subscription-set">
                  <div className="subscription">
                    <div className="price">€ 595</div>
                  </div>
                  <Link to="/signUp">
                  <button className="btn white rounded">Sign Up</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  )
}



// WEBPACK FOOTER //
// ./src/modules/landing/components/Tutorials.js